import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools"

const overrides = {
  initialColorMode: 'system', // 'light', // or 'dark' / 'system'
  useSystemColorMode: true,
    styles: {
        global: (props: any) => ({
            body: {
                ".css-f6n2t5": {
                    minWidth: "auto",
                    bg: mode("teal", "gray.900")(props),
                    color: mode("white", "black")(props),
                },
            },
        }),
    },
semanticTokens: {
    colors: {
      // Sobrescribe solo las escalas que usan los componentes (ej. 500 y 600)
      "teal.500": {
        _light: "rgb(49, 151, 149)", // Mantiene el original en light mode teal standard
        _dark: "cyan.500",   // Cambia a un color diferente (ej. un rojo) en dark mode
      },
      "teal.200": {
        _light: "teal.200",
        _dark: "cyan.200",   // Ajusta los tonos claros usados en variantes 'outline' o 'ghost'
      },
    },
  },
};

export default extendTheme(overrides);
